import React from 'react';
import {useTranslation} from 'react-i18next';

import Form from 'components/common/Form';
import Select from 'components/common/Form/Select';
import Button, {ButtonStyles} from 'components/common/Form/Button';

import {Specialities, SubSpecialities, HealthCareFacility} from 'constants/MedicalInformation';
import YearsOfExperience from 'constants/YearsOfExperience';

import {convertToOptions, convertToValue} from 'helpers/SelectUtils';

import style from 'components/Welcome/Form/Form.module.scss';

const MedicalForm = ({data, errors, onPreviousStep, isLastStep, onNextStep, onChange}) => {
    const {t} = useTranslation();

    return (
        <div className={style.profileFormContainer}>
            <Form>
                <div className={style.inlineFieldsContainer}>
                    <Select
                        fullWidth
                        label={t('welcome:text.speciality')}
                        placeholder={t('welcome:text.speciality')}
                        name='speciality'
                        error={t(errors.speciality)}
                        value={data.speciality}
                        options={Specialities}
                        onChangeField={onChange}
                        className={style.select}
                    />
                    <Select
                        fullWidth
                        label={t('welcome:text.subSpeciality')}
                        placeholder={t('welcome:text.subSpeciality')}
                        name='subSpeciality'
                        error={t(errors.subSpeciality)}
                        value={data.subSpeciality}
                        options={SubSpecialities[data.speciality] || []}
                        onChangeField={onChange}
                        className={style.select}
                    />
                </div>
                <div className={style.inlineFieldsContainer}>
                    <Select
                        fullWidth
                        label={t('welcome:text.healthCareFacility')}
                        placeholder={t('welcome:text.healthCareFacility')}
                        name='healthCareFacility'
                        value={convertToValue(data.healthCareFacility, HealthCareFacility)}
                        error={t(errors.healthCareFacility)}
                        options={convertToOptions(HealthCareFacility)}
                        onChangeField={onChange}
                        className={style.select}
                    />
                    <Select
                        fullWidth
                        label={t('welcome:text.medicalExperience')}
                        placeholder={t('welcome:text.medicalExperience')}
                        name='experience'
                        value={data.experience}
                        error={t(errors.experience)}
                        options={YearsOfExperience}
                        onChangeField={onChange}
                        className={style.select}
                    />
                </div>
                {isLastStep && <div className={style.commonError}>{errors.common}</div>}
                <Button text={t('welcome:buttons.back')} onClick={onPreviousStep} />
                <Button
                    text={isLastStep ? t('welcome:buttons.getStarted') : t('welcome:buttons.continue')}
                    onClick={() => onNextStep(isLastStep)}
                    btnStyle={ButtonStyles.primary}
                />
            </Form>
        </div>
    );
};

export default MedicalForm;
